import script from "./HelpManualModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpManualModal.vue?vue&type=script&setup=true&lang=js"

import "./HelpManualModal.vue?vue&type=style&index=0&id=82a37bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82a37bdc"]])

export default __exports__